import React, {useEffect, useState} from "react"
import "./UserRegistration.css"
import {getResource} from "../service/http-service";


export const UserAgreements = ({userInfo, setUserInfo, setPage}) => {

    const [isActiveRecruitments, setIsActiveRecruitments] = useState(false)

    const [conditionAgreement, setConditionAgreement] = useState(false)
    const [condititionForBase, setConditionForBase] = useState(false)
    const [conditionForRecruitment, setConditionForRecruitment] = useState(false)

    const [checkedFirstAgreement, setCheckedFirstAgreement] = useState(false)
    const [checkedBaseAgreement, setCheckedBaseAgreement] = useState(false)
    const [checkedApplyOnOneAgreement, setCheckedApplyOnOneAgreement] = useState(false)

    useEffect(()=> {
        getResource('portal_recruitment/check_active_recruitments').then(data => {
            setIsActiveRecruitments(data.data);
        })
        if(sessionStorage.getItem('firstAgreement')){
            setCheckedFirstAgreement(true)
            setConditionAgreement(true)
        }
        if(userInfo.agreementToBeKeptInDatabase === true){
            setCheckedBaseAgreement(true)
            setCheckedApplyOnOneAgreement(false)
            setConditionForBase(true)
            setConditionForRecruitment(false)
        } else if (userInfo.agreementToApplyOnOneAd === true){
            setCheckedBaseAgreement(false)
            setCheckedApplyOnOneAgreement(true)
            setConditionForBase(false)
            setConditionForRecruitment(true)
        }
    },[])

    useEffect(()=> {
        if(conditionAgreement === true){
            sessionStorage.setItem('firstAgreement', JSON.stringify(conditionAgreement))
        } else {
            sessionStorage.removeItem('firstAgreement')
        }
    },[conditionAgreement])

    return (
        <div className="basic-info mt-3">
           <div className="agreement-div d-flex flex-wrap justify-content-start align-items-center">
               <p>Со цел да се овозможи законита и транспарентна обработка на Вашите податоци во процесот на
                   регрутација - евалуација и селекција на кандидатите за вработување/кандидати за практиканти и
                   Ваше запознавање со начинот на кој постапуваме со Вашите лични податоци, потребно е детално да ја прочитате
                   <b> Информацијата за приватност за кандидатите за вработување и практиканство на АЛКАЛОИД, </b>
                   која е поставена на следниот <a href="https://alkaloid.com.mk/mk/zashtita-na-lichni-podatoci" target='_blank'>линк</a></p>
              <div className='w-100'>
                  <input type='checkbox' id="conditionAgreement" name="conditionAgreement" value={conditionAgreement}
                         checked={checkedFirstAgreement}
                           onClick={()=> {
                               setConditionAgreement(!conditionAgreement)
                               setCheckedFirstAgreement(!checkedFirstAgreement)
                           }}

              />
                  <label htmlFor="conditionAgreement">
                     <span>*</span> Потврдувам дека ја прочитав горенаведената Информација
                  </label></div>
           </div>

            {conditionAgreement && <><div className="agreement-div d-flex flex-wrap justify-content-start align-items-center">
                <div className="d-flex justify-content-start align-items-center w-100">
                    <input type="radio" id="inBase" name="agreement" value={userInfo.agreementToBeKeptInDatabase}
                           checked={checkedBaseAgreement}
                           onClick={(e) => {
                               setUserInfo({...userInfo, agreementToBeKeptInDatabase: true, agreementToApplyOnOneAd: false })
                                setConditionForBase(true)
                                setCheckedBaseAgreement(true)
                               setCheckedApplyOnOneAgreement(false)
                           }}/>
                    <label htmlFor="inBase">
                        Се согласувам моите лични податоци и приложената документација да се обработуваат и чуваат во рок од три (3) години
                        од датумот на аплицирање, а со цел учество во процесот на евалуација и селекција на кандидати за вработување/кандидати
                        за практиканти при отворање на идни работни позиции/позиции за практиканти во Алкалоид АД Скопје и
                        капитално поврзаните друштва АЛКАЛОИД КОНС и АЛКАЛОИД Билна аптека.
                    </label>
                </div>
                {isActiveRecruitments && <>
                    <div className="text-white mt-3">
                        Изјавите кои следуваат подолу се однесуваат само на кандидатите за вработување:
                    </div>
                    <div className="d-flex justify-content-start align-items-center w-100 mt-3 mb-5">
                    <input type="radio" id="notInBase" name="agreement" value={userInfo.agreementToApplyOnOneAd}
                           checked={checkedApplyOnOneAgreement}
                           onClick={(e)=> {
                               setUserInfo({...userInfo, agreementToApplyOnOneAd: true, agreementToBeKeptInDatabase: false})
                               setConditionForRecruitment(true)
                               setCheckedBaseAgreement(false)
                               setCheckedApplyOnOneAgreement(true)
                           }}/>
                    <label htmlFor="notInBase">
                        Се согласувам моите лични податоци и приложената документација да се обработуваат и
                        чуваат исклучиво за времетраење на процесот на евалуација и селекција на кандидати за вработување и
                        избор на нови вработени за соодветната работна позиција за која аплицирам.
                    </label>
                    </div>
                </>}
                <div className=" w-100">
                    <input type="checkbox" id="forMailNotifications" name="forMailNotifications"
                           checked={userInfo.agreementForReceivingNotifications}
                           value={userInfo.agreementForReceivingNotifications}
                           onClick={(e) =>
                               setUserInfo({...userInfo, agreementForReceivingNotifications: !userInfo.agreementForReceivingNotifications})}/>
                    <label htmlFor="forMailNotifications">
                        Се согласувам да добивам нотификации за нови отворени работни позиции согласно означеното поле на интерес
                    </label>
                </div>
            </div>
                {(condititionForBase || conditionForRecruitment ) && <div className='form-footer text-center'>
                    <button onClick={() => setPage(1)}>Следна</button>
                </div>}
            </>}
        </div>
    )
}